import { themeOptionFactory as MobileThemeOptionFactory } from "./directory-mobile.theme"
import { themeOptionFactory as KiokVthemeOptionFactory } from "./directory-v-standard.theme"
import { themeOptionFactory as KiokHthemeOptionFactory } from "./directory-h-standard.theme"
export const appThemeOptionFactory = {
  mobile: MobileThemeOptionFactory,
  "kiosk-v": KiokVthemeOptionFactory,
  "kiosk-h": KiokHthemeOptionFactory,
}
